<div class="container">
	<div class="row">
		<h1>
			{{ "it.navigation.search" | translate }}
		</h1>
	</div>
	<div class="row py-4">
		<form #searchForm="ngForm" (ngSubmit)="onSearchSubmit(searchForm)">
			<it-select
				name="authority"
				[label]="'iterlex.authority' | translate"
				ngModel
				required
			>
				<option selected value="">
					{{ "iterlex.select-authority" | translate }}
				</option>
				@for (authority of authorities; track authority.id) {
					@if (authority.children.length > 0) {
						@for (body of authority.children; track body.id) {
							<option [value]="authority.id + '/' + body.id">
								{{
									authority.label[
										"iterlex.currentLanguage" | translate
									]
								}}
								/
								{{
									body.label[
										"iterlex.currentLanguage" | translate
									]
								}}
							</option>
						}
					} @else {
						<option [value]="authority.id + '/' + authority.id">
							{{
								authority.label[
									"iterlex.currentLanguage" | translate
								]
							}}
						</option>
					}
				}
			</it-select>
			<it-input
				type="text"
				name="title"
				ngModel
				[label]="'iterlex.title' | translate"
			></it-input>
			<it-input
				type="text"
				name="number"
				ngModel
				[label]="'iterlex.number' | translate"
			></it-input>
			<it-input
				type="number"
				name="year"
				ngModel
				[label]="'iterlex.year' | translate"
			></it-input>
			<it-select
				name="state"
				[label]="'iterlex.dossier-state' | translate"
				ngModel
			>
				<option selected value="">
					{{ "iterlex.select-dossier-state" | translate }}
				</option>
				@for (state of dossierStates; track state) {
					<option selected [value]="state">
						{{ "iterlex.dossier-state-" + state | translate }}
					</option>
				}
			</it-select>
			<button
				itButton="primary"
				type="submit"
				size="xs"
				[disabled]="!searchForm.valid"
			>
				{{ "it.navigation.search" | translate }}
			</button>
		</form>
	</div>
	<div class="row">
		@for (dossier of dossiers; track dossier.workUri) {
			<div class="col-md-6 col-lg-4">
				<div class="card-wrapper card-space">
					<app-dossier
						class="w-100"
						[dossier]="dossier"
						[dossierType]="getDossierType(dossier.type)"
					/>
				</div>
			</div>
		}
	</div>
</div>
